import axios from 'axios';

const BASE = process.env.REACT_APP_API_BASE || '/api/v1';

export const api = axios.create({ baseURL: BASE });


api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('kb_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  res => res.data,
  err => Promise.reject(err.response?.data || { message: 'Network error' })
);

// ── Auth ──────────────────────────────────────────────────────────────────────
export const auth = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
  updateProfile: (data) => api.patch('/profile', data),
  changePassword: (data) => api.patch('/profile/password', data),
};

// ── Jobs ──────────────────────────────────────────────────────────────────────
export const jobs = {
  list: (params) => api.get('/jobs', { params }),
  get: (id) => api.get(`/jobs/${id}`),
  create: (data) => api.post('/jobs', data),
  apply: (id, data) => api.post(`/jobs/${id}/apply`, data),
  applicants: (id) => api.get(`/jobs/${id}/applicants`),
  select: (id, data) => api.post(`/jobs/${id}/select`, data),
  markComplete: (id) => api.post(`/jobs/${id}/complete`),
  verify: (id) => api.post(`/jobs/${id}/verify`),
  unlockContact: (id) => api.post(`/jobs/${id}/contact`),
};

// ── Seek Ads ──────────────────────────────────────────────────────────────────
export const seekAds = {
  list: (params) => api.get('/seek-ads', { params }),
  get: (id) => api.get(`/seek-ads/${id}`),
  my: (params) => api.get('/seek-ads/my', { params }),
  create: (data) => api.post('/seek-ads', data),
  update: (id, data) => api.put(`/seek-ads/${id}`, data),
  close: (id) => api.delete(`/seek-ads/${id}`),
  pause: (id) => api.patch(`/seek-ads/${id}/pause`),
  activate: (id) => api.patch(`/seek-ads/${id}/activate`),
  unlockContact: (id) => api.post(`/seek-ads/${id}/contact`),
  sendHireRequest: (id, data) => api.post(`/seek-ads/${id}/hire-request`, data),
  hireRequests: (id) => api.get(`/seek-ads/${id}/hire-requests`),
};

// ── Hire Requests ─────────────────────────────────────────────────────────────
export const hireRequests = {
  my: () => api.get('/hire-requests/my'),
  respond: (id, status) => api.patch(`/hire-requests/${id}/respond`, { status }),
};

// ── Tokens ────────────────────────────────────────────────────────────────────
export const tokens = {
  balance: () => api.get('/tokens/balance'),
  request: (data) => api.post('/tokens/request', data),
  myRequests: () => api.get('/tokens/requests/my'),
  pending: () => api.get('/tokens/requests'),
  approve: (id) => api.patch(`/tokens/requests/${id}/approve`),
  reject: (id, data) => api.patch(`/tokens/requests/${id}/reject`, data),
};

// ── Notifications ─────────────────────────────────────────────────────────────
export const notifications = {
  list: (params) => api.get('/notifications', { params }),
  unreadCount: () => api.get('/notifications/unread-count'),
  markRead: (id) => api.patch(`/notifications/${id}/read`),
  markAllRead: () => api.patch('/notifications/read-all'),
};

// ── Admin ─────────────────────────────────────────────────────────────────────
export const admin = {
  stats: () => api.get('/admin/stats'),
  users: (params) => api.get('/admin/users', { params }),
  moderators: (params) => api.get('/admin/moderators', { params }),
  approveModerator: (id) => api.patch(`/admin/moderators/${id}/approve`),
  rejectModerator: (id) => api.patch(`/admin/moderators/${id}/reject`),
  getConfig: () => api.get('/admin/config'),
  updateConfig: (data) => api.patch('/admin/config', data),
  getTraffic: () => api.get('/admin/traffic'),
  deactivateUser: (id) => api.patch(`/admin/users/${id}/deactivate`),
  activateUser: (id) => api.patch(`/admin/users/${id}/activate`),
  updateTokens: (id, data) => api.patch(`/admin/users/${id}/tokens`, data),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
  getUserDetails: (id) => api.get(`/admin/users/${id}`),
};

// ── Admin / Moderation ─────────────────────────────────────────────────────────
export const adminJobs = {
  list: (params) => api.get('/admin/jobs', { params }),
  close: (id) => api.patch(`/admin/jobs/${id}/close`),
  delete: (id) => api.delete(`/admin/jobs/${id}`),
};

export const adminSeekAds = {
  list: (params) => api.get('/admin/seek-ads', { params }),
  close: (id) => api.patch(`/admin/seek-ads/${id}/close`),
  delete: (id) => api.delete(`/admin/seek-ads/${id}`),
};



export default api;
